var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({'background-color':_vm.$vuetify.theme.themes.light.primary +' !important'}),attrs:{"id":"app"}},[_c('logos',{attrs:{"src":_vm.$headerLogo,"alt":"Idonia"}}),_c('v-main',[_c('register-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }